import { createSvgIcon } from "./create-svg-icon";

export const Document = createSvgIcon(
  <svg viewBox="-0.5 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6375 7.95372V14.7518C14.6375 15.6772 13.8803 16.4273 12.9463 16.4273H5.054C4.11997 16.4273 3.36279 15.6772 3.36279 14.7518V3.58165C3.36279 2.65628 4.11997 1.90613 5.054 1.90613H8.53331C8.83223 1.90617 9.1189 2.02382 9.33029 2.2332L14.3074 7.16413C14.5187 7.37356 14.6375 7.65757 14.6375 7.95372Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 2.20044V6.38329C9 6.99932 9.50339 7.49871 10.1243 7.49871H14.3407"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
